<template>
  <Head>
    <Title>
      {{ title || getMenu?.name }} | {{ translate("website.title.suffix") }}
    </Title>

    <Meta name="robots" :content="robots" v-if="robots" />

    <Meta name="google-site-verification" :content="verification" v-if="verification" />
    <Meta name="title" :content="title ?? getMenu?.name" v-if="title" />
    <Meta name="description" :content="description" v-if="description" />
    <Meta property="og:title" :content="title ?? getMenu?.name" v-if="title" />
    <Meta property="og:description" :content="description" v-if="description" />
    <Meta property="og:image" :content="image" v-if="image" />
    <Meta property="og:image:alt" :content="title ?? getMenu?.name" v-if="title" />
    <Meta name="twitter:card" content="summary_large_image" />
    <Meta name="twitter:title" :content="title ?? getMenu?.name" v-if="title" />
    <Meta name="twitter:description" :content="description" v-if="description" />
    <Meta name="twitter:image" :content="image || getMenu?.image" v-if="image" />

  </Head>

  <article>
    <slot />
  </article>

</template>

<script setup>

import { useTranslationStore } from "@/stores/translations";
import { useMenusStore } from "@/stores/menus";
import { onMounted } from "vue";

const ogImage = ref("/static/images/si-og.jpg");

const translationStore = useTranslationStore();
const translate = translationStore.translate;
const getMenu = ref(null);

const { locale } = useI18n();
useHead({

htmlAttrs: {
    lang: locale
},
})

const props = defineProps({
  path: {
    type: String,
    required: true,
  },
  title: {
    type: String
  },
  description: {
    type: String
  },
  image: {
    type: String
  },
  robots: {
    type: String
  },
  verification: {
    type: String
  },
});

onMounted(async() => {

  if(props.path != null) {

    const menusStore = useMenusStore();
    await menusStore.searchMenu(props.path);

    getMenu.value = menusStore?.menu;

  }

})



</script>

<style lang="scss" scoped></style>
